var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3f5ae9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ENERG\\xCDA"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.73,71.57l-1.91,60.44c12.36-9.4,25.96-16.84,40.36-22.15l37.04-59.72-28.59-46.1c-35.15,6.31-68.59,19.91-98.22,40.02l51.32,27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.79,146.01l28.9,53.92c6.73-17.48,16.58-33.66,29.3-47.8l2.15-68.09-48.43-25.96c-3.22,2.65-6.41,5.35-9.52,8.16-25.76,23.32-46.1,51.03-60.34,81.61l57.95-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.13,252.02l1.86,1.15,50.93,31.59c-2.21-11.88-3.05-24.1-2.44-36.48.5-10.06,1.97-19.91,4.31-29.48l-31.3-58.4-55.78,1.76C7.65,187.74,1.72,215.06.32,243.31c-.65,13.13-.3,26.15,1,38.99l48.82-30.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.82,445.77c52.25-47.31,82.11-112.19,84.08-182.67,1.85-66.23-21.64-129.77-66.13-178.92C397.33,30.68,328.13,0,255.92,0c-4.78,0-9.55.15-14.3.41l30.84,49.73-31.55,50.87c4.97-.48,9.98-.73,15.01-.73,43.94,0,86.05,18.66,115.51,51.2,27.06,29.89,41.35,68.54,40.23,108.82-1.2,42.89-19.36,82.35-51.14,111.13-28.69,25.98-65.78,40.29-104.43,40.29-43.95,0-86.05-18.66-115.51-51.2-17.34-19.15-29.4-41.79-35.56-66.14l-54.89-34.04-47.9,29.71c6.74,51.04,28.71,98.8,64.01,137.78,48.44,53.5,117.64,84.18,189.85,84.18,63.57,0,124.57-23.52,171.74-66.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergia);
export default __webpack_public_path__ + "static/media/ENERGIA.8d672cd7a5bcb7693eec5dcd765868b2.svg";
export { ForwardRef as ReactComponent };